import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f4f04536 = () => interopDefault(import('../pages/about-idioma.vue' /* webpackChunkName: "pages/about-idioma" */))
const _27f73b59 = () => interopDefault(import('../pages/ask.vue' /* webpackChunkName: "pages/ask" */))
const _5348b11c = () => interopDefault(import('../pages/blog.vue' /* webpackChunkName: "pages/blog" */))
const _39155075 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _6441ec46 = () => interopDefault(import('../pages/blog/archive/_archive.vue' /* webpackChunkName: "pages/blog/archive/_archive" */))
const _60145cdd = () => interopDefault(import('../pages/blog/tag/_tag.vue' /* webpackChunkName: "pages/blog/tag/_tag" */))
const _375eaf2d = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _5006fe8a = () => interopDefault(import('../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _4fb940d0 = () => interopDefault(import('../pages/crosscheck.vue' /* webpackChunkName: "pages/crosscheck" */))
const _78eb362e = () => interopDefault(import('../pages/data-protection-and-privacy-policy.vue' /* webpackChunkName: "pages/data-protection-and-privacy-policy" */))
const _1213b576 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _3e60f3a2 = () => interopDefault(import('../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _9e20d426 = () => interopDefault(import('../pages/idioma-nmt.vue' /* webpackChunkName: "pages/idioma-nmt" */))
const _ba4fb532 = () => interopDefault(import('../pages/iglossary.vue' /* webpackChunkName: "pages/iglossary" */))
const _05887868 = () => interopDefault(import('../pages/industries.vue' /* webpackChunkName: "pages/industries" */))
const _0c4a2038 = () => interopDefault(import('../pages/isync.vue' /* webpackChunkName: "pages/isync" */))
const _6a8d60dc = () => interopDefault(import('../pages/languages-supported.vue' /* webpackChunkName: "pages/languages-supported" */))
const _50ee0223 = () => interopDefault(import('../pages/news.vue' /* webpackChunkName: "pages/news" */))
const _fba9bb34 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _ff16fdc4 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _0e0c0f76 = () => interopDefault(import('../pages/nextdoc.vue' /* webpackChunkName: "pages/nextdoc" */))
const _1dec2930 = () => interopDefault(import('../pages/nmt-plus-pe.vue' /* webpackChunkName: "pages/nmt-plus-pe" */))
const _0ce506f3 = () => interopDefault(import('../pages/our-history.vue' /* webpackChunkName: "pages/our-history" */))
const _2664f8e4 = () => interopDefault(import('../pages/our-organization.vue' /* webpackChunkName: "pages/our-organization" */))
const _64eba33c = () => interopDefault(import('../pages/our-philosophy.vue' /* webpackChunkName: "pages/our-philosophy" */))
const _5a8931eb = () => interopDefault(import('../pages/password.vue' /* webpackChunkName: "pages/password" */))
const _229bba72 = () => interopDefault(import('../pages/project-management.vue' /* webpackChunkName: "pages/project-management" */))
const _1c419305 = () => interopDefault(import('../pages/resources.vue' /* webpackChunkName: "pages/resources" */))
const _4f3dee2e = () => interopDefault(import('../pages/services.vue' /* webpackChunkName: "pages/services" */))
const _a55a0b60 = () => interopDefault(import('../pages/stream.vue' /* webpackChunkName: "pages/stream" */))
const _969fc2c6 = () => interopDefault(import('../pages/stream-api.vue' /* webpackChunkName: "pages/stream-api" */))
const _21938044 = () => interopDefault(import('../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _813ab5d8 = () => interopDefault(import('../pages/translation-in-iqube.vue' /* webpackChunkName: "pages/translation-in-iqube" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bb4ea752 = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _4b12f6c8 = () => interopDefault(import('../pages/_ui/colors.vue' /* webpackChunkName: "pages/_ui/colors" */))
const _fdd28cc4 = () => interopDefault(import('../pages/_ui/icons.vue' /* webpackChunkName: "pages/_ui/icons" */))
const _90544a4a = () => interopDefault(import('../pages/_ui/typography.vue' /* webpackChunkName: "pages/_ui/typography" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-idioma",
    component: _f4f04536,
    name: "about-idioma___en"
  }, {
    path: "/ask",
    component: _27f73b59,
    name: "ask___en"
  }, {
    path: "/blog",
    component: _5348b11c,
    children: [{
      path: "",
      component: _39155075,
      name: "blog___en"
    }, {
      path: "archive/:archive?",
      component: _6441ec46,
      name: "blog-archive-archive___en"
    }, {
      path: "tag/:tag?",
      component: _60145cdd,
      name: "blog-tag-tag___en"
    }, {
      path: ":slug",
      component: _375eaf2d,
      name: "blog-slug___en"
    }]
  }, {
    path: "/contact-us",
    component: _5006fe8a,
    name: "contact-us___en"
  }, {
    path: "/crosscheck",
    component: _4fb940d0,
    name: "crosscheck___en"
  }, {
    path: "/data-protection-and-privacy-policy",
    component: _78eb362e,
    name: "data-protection-and-privacy-policy___en"
  }, {
    path: "/faq",
    component: _1213b576,
    name: "faq___en"
  }, {
    path: "/home",
    component: _3e60f3a2,
    name: "home___en"
  }, {
    path: "/idioma-nmt",
    component: _9e20d426,
    name: "idioma-nmt___en"
  }, {
    path: "/iglossary",
    component: _ba4fb532,
    name: "iglossary___en"
  }, {
    path: "/industries",
    component: _05887868,
    name: "industries___en"
  }, {
    path: "/isync",
    component: _0c4a2038,
    name: "isync___en"
  }, {
    path: "/languages-supported",
    component: _6a8d60dc,
    name: "languages-supported___en"
  }, {
    path: "/news",
    component: _50ee0223,
    children: [{
      path: "",
      component: _fba9bb34,
      name: "news___en"
    }, {
      path: ":slug",
      component: _ff16fdc4,
      name: "news-slug___en"
    }]
  }, {
    path: "/nextdoc",
    component: _0e0c0f76,
    name: "nextdoc___en"
  }, {
    path: "/nmt-plus-pe",
    component: _1dec2930,
    name: "nmt-plus-pe___en"
  }, {
    path: "/our-history",
    component: _0ce506f3,
    name: "our-history___en"
  }, {
    path: "/our-organization",
    component: _2664f8e4,
    name: "our-organization___en"
  }, {
    path: "/our-philosophy",
    component: _64eba33c,
    name: "our-philosophy___en"
  }, {
    path: "/password",
    component: _5a8931eb,
    name: "password___en"
  }, {
    path: "/project-management",
    component: _229bba72,
    name: "project-management___en"
  }, {
    path: "/resources",
    component: _1c419305,
    name: "resources___en"
  }, {
    path: "/services",
    component: _4f3dee2e,
    name: "services___en"
  }, {
    path: "/stream",
    component: _a55a0b60,
    name: "stream___en"
  }, {
    path: "/stream-api",
    component: _969fc2c6,
    name: "stream-api___en"
  }, {
    path: "/terms-and-conditions",
    component: _21938044,
    name: "terms-and-conditions___en"
  }, {
    path: "/translation-in-iqube",
    component: _813ab5d8,
    name: "translation-in-iqube___en"
  }, {
    path: "/ja/",
    component: _e542f99c,
    name: "index___ja"
  }, {
    path: "/ja/about-idioma",
    component: _f4f04536,
    name: "about-idioma___ja"
  }, {
    path: "/ja/ask",
    component: _27f73b59,
    name: "ask___ja"
  }, {
    path: "/ja/blog",
    component: _5348b11c,
    children: [{
      path: "",
      component: _39155075,
      name: "blog___ja"
    }, {
      path: "archive/:archive?",
      component: _6441ec46,
      name: "blog-archive-archive___ja"
    }, {
      path: "tag/:tag?",
      component: _60145cdd,
      name: "blog-tag-tag___ja"
    }, {
      path: ":slug",
      component: _375eaf2d,
      name: "blog-slug___ja"
    }]
  }, {
    path: "/ja/contact-us",
    component: _5006fe8a,
    name: "contact-us___ja"
  }, {
    path: "/ja/crosscheck",
    component: _4fb940d0,
    name: "crosscheck___ja"
  }, {
    path: "/ja/data-protection-and-privacy-policy",
    component: _78eb362e,
    name: "data-protection-and-privacy-policy___ja"
  }, {
    path: "/ja/faq",
    component: _1213b576,
    name: "faq___ja"
  }, {
    path: "/ja/home",
    component: _3e60f3a2,
    name: "home___ja"
  }, {
    path: "/ja/idioma-nmt",
    component: _9e20d426,
    name: "idioma-nmt___ja"
  }, {
    path: "/ja/iglossary",
    component: _ba4fb532,
    name: "iglossary___ja"
  }, {
    path: "/ja/impressum",
    component: _bb4ea752,
    name: "impressum___ja"
  }, {
    path: "/ja/industries",
    component: _05887868,
    name: "industries___ja"
  }, {
    path: "/ja/isync",
    component: _0c4a2038,
    name: "isync___ja"
  }, {
    path: "/ja/languages-supported",
    component: _6a8d60dc,
    name: "languages-supported___ja"
  }, {
    path: "/ja/news",
    component: _50ee0223,
    children: [{
      path: "",
      component: _fba9bb34,
      name: "news___ja"
    }, {
      path: ":slug",
      component: _ff16fdc4,
      name: "news-slug___ja"
    }]
  }, {
    path: "/ja/nextdoc",
    component: _0e0c0f76,
    name: "nextdoc___ja"
  }, {
    path: "/ja/nmt-plus-pe",
    component: _1dec2930,
    name: "nmt-plus-pe___ja"
  }, {
    path: "/ja/our-history",
    component: _0ce506f3,
    name: "our-history___ja"
  }, {
    path: "/ja/our-organization",
    component: _2664f8e4,
    name: "our-organization___ja"
  }, {
    path: "/ja/our-philosophy",
    component: _64eba33c,
    name: "our-philosophy___ja"
  }, {
    path: "/ja/password",
    component: _5a8931eb,
    name: "password___ja"
  }, {
    path: "/ja/project-management",
    component: _229bba72,
    name: "project-management___ja"
  }, {
    path: "/ja/resources",
    component: _1c419305,
    name: "resources___ja"
  }, {
    path: "/ja/services",
    component: _4f3dee2e,
    name: "services___ja"
  }, {
    path: "/ja/stream",
    component: _a55a0b60,
    name: "stream___ja"
  }, {
    path: "/ja/stream-api",
    component: _969fc2c6,
    name: "stream-api___ja"
  }, {
    path: "/ja/terms-and-conditions",
    component: _21938044,
    name: "terms-and-conditions___ja"
  }, {
    path: "/ja/translation-in-iqube",
    component: _813ab5d8,
    name: "translation-in-iqube___ja"
  }, {
    path: "/sv/",
    component: _e542f99c,
    name: "index___sv"
  }, {
    path: "/sv/about-idioma",
    component: _f4f04536,
    name: "about-idioma___sv"
  }, {
    path: "/sv/ask",
    component: _27f73b59,
    name: "ask___sv"
  }, {
    path: "/sv/blog",
    component: _5348b11c,
    children: [{
      path: "",
      component: _39155075,
      name: "blog___sv"
    }, {
      path: "archive/:archive?",
      component: _6441ec46,
      name: "blog-archive-archive___sv"
    }, {
      path: "tag/:tag?",
      component: _60145cdd,
      name: "blog-tag-tag___sv"
    }, {
      path: ":slug",
      component: _375eaf2d,
      name: "blog-slug___sv"
    }]
  }, {
    path: "/sv/contact-us",
    component: _5006fe8a,
    name: "contact-us___sv"
  }, {
    path: "/sv/crosscheck",
    component: _4fb940d0,
    name: "crosscheck___sv"
  }, {
    path: "/sv/data-protection-and-privacy-policy",
    component: _78eb362e,
    name: "data-protection-and-privacy-policy___sv"
  }, {
    path: "/sv/faq",
    component: _1213b576,
    name: "faq___sv"
  }, {
    path: "/sv/home",
    component: _3e60f3a2,
    name: "home___sv"
  }, {
    path: "/sv/idioma-nmt",
    component: _9e20d426,
    name: "idioma-nmt___sv"
  }, {
    path: "/sv/iglossary",
    component: _ba4fb532,
    name: "iglossary___sv"
  }, {
    path: "/sv/impressum",
    component: _bb4ea752,
    name: "impressum___sv"
  }, {
    path: "/sv/industries",
    component: _05887868,
    name: "industries___sv"
  }, {
    path: "/sv/isync",
    component: _0c4a2038,
    name: "isync___sv"
  }, {
    path: "/sv/languages-supported",
    component: _6a8d60dc,
    name: "languages-supported___sv"
  }, {
    path: "/sv/news",
    component: _50ee0223,
    children: [{
      path: "",
      component: _fba9bb34,
      name: "news___sv"
    }, {
      path: ":slug",
      component: _ff16fdc4,
      name: "news-slug___sv"
    }]
  }, {
    path: "/sv/nextdoc",
    component: _0e0c0f76,
    name: "nextdoc___sv"
  }, {
    path: "/sv/nmt-plus-pe",
    component: _1dec2930,
    name: "nmt-plus-pe___sv"
  }, {
    path: "/sv/our-history",
    component: _0ce506f3,
    name: "our-history___sv"
  }, {
    path: "/sv/our-organization",
    component: _2664f8e4,
    name: "our-organization___sv"
  }, {
    path: "/sv/our-philosophy",
    component: _64eba33c,
    name: "our-philosophy___sv"
  }, {
    path: "/sv/password",
    component: _5a8931eb,
    name: "password___sv"
  }, {
    path: "/sv/project-management",
    component: _229bba72,
    name: "project-management___sv"
  }, {
    path: "/sv/resources",
    component: _1c419305,
    name: "resources___sv"
  }, {
    path: "/sv/services",
    component: _4f3dee2e,
    name: "services___sv"
  }, {
    path: "/sv/stream",
    component: _a55a0b60,
    name: "stream___sv"
  }, {
    path: "/sv/stream-api",
    component: _969fc2c6,
    name: "stream-api___sv"
  }, {
    path: "/sv/terms-and-conditions",
    component: _21938044,
    name: "terms-and-conditions___sv"
  }, {
    path: "/sv/translation-in-iqube",
    component: _813ab5d8,
    name: "translation-in-iqube___sv"
  }, {
    path: "/ja/:ui/colors",
    component: _4b12f6c8,
    name: "ui-colors___ja"
  }, {
    path: "/ja/:ui/icons",
    component: _fdd28cc4,
    name: "ui-icons___ja"
  }, {
    path: "/ja/:ui/typography",
    component: _90544a4a,
    name: "ui-typography___ja"
  }, {
    path: "/sv/:ui/colors",
    component: _4b12f6c8,
    name: "ui-colors___sv"
  }, {
    path: "/sv/:ui/icons",
    component: _fdd28cc4,
    name: "ui-icons___sv"
  }, {
    path: "/sv/:ui/typography",
    component: _90544a4a,
    name: "ui-typography___sv"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index___en"
  }, {
    path: "/:ui/colors",
    component: _4b12f6c8,
    name: "ui-colors___en"
  }, {
    path: "/:ui/icons",
    component: _fdd28cc4,
    name: "ui-icons___en"
  }, {
    path: "/:ui/typography",
    component: _90544a4a,
    name: "ui-typography___en"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
